module.exports = __webpack_public_path__ + "img/4.68dd9146.png";